import React from 'react';
import MetafieldDefinitionsPage from './MetafieldDefinitionsPage';

export default function VariantMetafields() {
  return (
    <MetafieldDefinitionsPage
      ownerType="PRODUCTVARIANT"
      title="Variant Metafields"
      routePrefix="/metafields/variant"
    />
  );
}
